module.exports = __webpack_public_path__ + "img/activation_location_mp.c926390b.svg";